export default __webpack_public_path__ + "static/media/421.16727258.jpg";